export default "__VITE_ASSET__b619cd0e__"